import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Screens from "./Screens";

const style = {
  margin: 12
};

const attrStyle = {
  width: 200,
  color: "#dd22dd",
  lineHeight: 2.0,
  fontSize: 14,
  padding: 0
};
const valueStyle = {
  width: 200,
  color: "#444444",
  lineHeight: 2.0,
  fontSize: 18,
  padding: 0
};

class AppOverview extends Component {
  constructor(props) {
    super(props);

    this.onScreenClicked = this.onScreenClicked.bind(this);
  }

  onScreenClicked(screen) {
    console.log("clicked screen " + screen.name + " with id " + screen.id);
    this.props.onGoToScreen(screen);
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div
          style={{
            width: 500,
            padding: 12,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <table style={{ width: "fit-content" }}>
            <tr>
              <td style={attrStyle}>App name: </td>
              <td style={valueStyle}>{this.props.app.name}</td>
            </tr>
            <tr>
              <td style={attrStyle}>Min Android version: </td>
              <td style={valueStyle}>
                {this.props.app.minimumDeviceAndroidVersion}
              </td>
            </tr>
          </table>
          <br />
          <br />
          <br />
          Screens:
          <Screens
            screens={this.props.app.screens}
            onItemClicked={this.onScreenClicked}
          />
        </div>
      </div>
    );
  }
}

export default AppOverview;



// WEBPACK FOOTER //
// ./src/components/AppOverview.js